<template>
<div class="page">
    <h1>Partnerships</h1>
    <div class="card">
        <h2>Universe Point</h2>
        <p>Commission: 6.5% on cleats</p>
        <p><strong>http://ultimatefrisbeehq.com</strong> is approved to refer to <strong>https://www.universepoint.com</strong>. Simply link from your site and referral credit will be given.</p>
        <p>Payout schedule matches <a href="https://affiliate-program.amazon.com/help/node/topic/202050210">Amazon's affiliate program</a></p>
    </div>
</div>
</template>

<script>
  export default {
    name: 'Partnerships'
  }
</script>

<style scoped>
.card {
  padding: 8px 32px;
  max-width: 600px;
  box-shadow: 0 2px 10px rgba(50,50,93,.11), 0 2px 5px rgba(0,0,0,.08);
  border-radius: 2px;
}
p {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partnerships.vue